// import { ENEXPECTED_ERROR, UPDATE_SUCCESSFUL } from "@/Constant";
import { MotifToast } from "@ey-xd/motif-react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
type NotificationProps = {
  show?: boolean;
  message?: string;
  type?: string;
  supportingText?: string;
  scrollToTop?: boolean;
  onClose?: ()=>void;
};

export default function NotificationGrid({
  show = true,
  message = "",
  type = "error",
  supportingText = "",
  scrollToTop = true,
  onClose
}: NotificationProps) {
  const [showMessage, setShowMessage] = useState({
    show: true,
    type: "error",
    message: "",
    supportingText: "",
  });
  
  const { t } = useTranslation();
  const toastRef = useRef<HTMLDivElement>(null);
  const closeMessageHandler = () => {
    setShowMessage({ ...showMessage, show: false, type: "error" });
    onClose && onClose();
  };
  useEffect(()=>{
setShowMessage({ show: show,
  type: type,
  message: message,
  supportingText: supportingText,})
  },[show,message,type,supportingText])

  useEffect(() => {
    if (scrollToTop && showMessage.show) {
      // Defer so the toast is mounted and painted before we scroll to it.
      const timer = setTimeout(() => {
        const el = toastRef.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const headerOffset = 80; // ~5rem fixed header
        const isVisible =
          rect.top >= headerOffset &&
          rect.bottom <= window.innerHeight;
        // Only scroll if the toast isn't already fully in view.
        if (!isVisible) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [scrollToTop, showMessage.show]);

  const notificationMessage =
    type === "error"
      ? message === ""
        ? "global.globalNotifications.unExpectedError"
        : message
      : message === ""
      ? "global.globalNotifications.updatedSuccessfully"
      : message;
  if (!showMessage.show) {
    return null;
  }

  return (
    <div ref={toastRef} style={{ scrollMarginTop: "5rem" }}>
      <MotifToast
        onClose={closeMessageHandler}
        //@ts-ignore
        variant={showMessage.type}
        supportingText={showMessage.supportingText}
      >
        {" "}
        {t(notificationMessage)}
      </MotifToast>
    </div>
  );
}
